import React from 'react';

type Mp4GifEmulatorProps = {
  src: string;
  className?: string;
};

const Mp4GifEmulator: React.FC<Mp4GifEmulatorProps> = ({ src, className }) => (
  <video autoPlay loop playsInline muted className={className}>
    <source src={src} type="video/mp4" />
  </video>
);

export default Mp4GifEmulator;



// WEBPACK FOOTER //
// ./src/components/common/ui/Mp4GifEmulator/Mp4GifEmulator.tsx